import icLinkExternal from 'assets/images/ic-link-external.svg'
import { Button, Spinner } from 'avo-ui'
import icMinusCircle from 'assets/images/ic-minus-circle.svg'
import icAddSquare from 'assets/images/ic-add-square.svg'
import { ACTION_TYPE } from 'constants/constant'
import Table from 'components/commons/table'
import ModalExport from 'components/commons/modal-export'
import { TABLE_USER_MEMBERSHIP_DETAIL } from 'configs/loyalty-program/configTableUserMembershipDetail'
import { formatDateMoment, setNumberWithPoint } from 'utils/utils'
import { FormPointDetail } from 'components/loyalty-program/user-membership-detail/FormPointDetail'

export const UserMembershipDetail = ({
    dataList,
    userProfile,
    modal,
    setShowModal,
    query,
    onChangeQuery,
    onExport,
    onActionRow,
    onChangeForm,
    onSubmit,
    onHideForm,
    actionForm,
    errorForm,
    pointDetail,
    isLoading,
    isLoadingProfile,
    isExporting,
    isAdding,
    isReducing,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex justify-between p-6 rounded-xl bg-neutral-5'}>
                {isLoadingProfile ? (
                    <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
                ) : (
                    <>
                        <div className={'flex flex-col space-y-2'}>
                            <p className={'text-lg font-bold capitalize'}>{userProfile?.name}</p>
                            <div className={'flex space-x-20'}>
                                <div className={'flex flex-col space-y-2'}>
                                    <p>{`Bergabung sejak ${formatDateMoment(userProfile?.created_at, 'DD MMMM YYYY')}`}</p>
                                    <p>{userProfile?.origin === 'online' ? 'Website' : 'Offline Store'}</p>
                                </div>
                                <div className={'flex flex-col space-y-2'}>
                                    <p>{userProfile?.email}</p>
                                    <p>{userProfile?.phone_number}</p>
                                </div>
                            </div>
                        </div>
                        <div className={'flex space-x-4 items-center'}>
                            <p className={'text-neutral-60 uppercase'}>Total Point</p>
                            <div className={'border border-gray-95 rounded bg-white py-4 px-10 '}>
                                <p className={'text-blue-90 text-lg font-bold'}>
                                    {setNumberWithPoint(userProfile?.total_point)}
                                </p>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className={'flex gap-3 flex-wrap justify-between mt-8'}>
                <Button
                    title={'Export'}
                    icon={icLinkExternal}
                    type={'outline'}
                    disabled={!dataList?.total_result}
                    onClick={() => setShowModal({ export: true })}
                />
                <div className={'flex space-x-3'}>
                    <Button
                        type={'outline'}
                        icon={icMinusCircle}
                        title={'Reduce Point'}
                        onClick={() => onActionRow(ACTION_TYPE.REDUCE)}
                    />
                    <Button
                        type={'outline'}
                        icon={icAddSquare}
                        title={'Add Point'}
                        onClick={() => onActionRow(ACTION_TYPE.ADD)}
                    />
                </div>
            </div>
            <Table
                className={'my-3'}
                name={TABLE_USER_MEMBERSHIP_DETAIL.name}
                columns={TABLE_USER_MEMBERSHIP_DETAIL.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={dataList?.total_result}
                    isLoading={isExporting}
                    onExport={onExport}
                />
            )}
            {modal?.form && (
                <FormPointDetail
                    show={modal?.form}
                    onHideForm={onHideForm}
                    dataPointDetail={pointDetail}
                    isLoading={isAdding || isReducing}
                    isAddForm={actionForm === ACTION_TYPE?.ADD}
                    onChangeForm={onChangeForm}
                    errorForm={errorForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
